import {
  CANCEL_CART_ROSTER_ENTRY_FORM,
  SET_ROSTERS_COMPLETE,
  SET_EVENTS_FOR_ROSTER_CHECKOUT
} from './constants';

const initialState = {
  cartEntries: [],
  rostersComplete: false
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case CANCEL_CART_ROSTER_ENTRY_FORM:
      return {
        ...state,
        editing: false
      };
    case SET_ROSTERS_COMPLETE:
      return {
        ...state,
        rostersComplete: payload || initialState.rostersComplete
      };      
    case SET_EVENTS_FOR_ROSTER_CHECKOUT:
      return {
        ...state,
        events: payload
    };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/reducer.js